import React, { FunctionComponent } from "react";
import { twMerge } from "tailwind-merge";

type ButtonProps = {
  variant?: "primary" | "secondary" | "accent";
  text: string;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  disabled?: boolean;
  loading?: boolean;
  loadingText?: string;
  onClick?: () => void;
  className?: string;
};

const FormButton: FunctionComponent<ButtonProps> = ({
  text,
  variant = "primary",
  type,
  disabled,
  loading,
  onClick,
  loadingText = "Loading...",
  className,
}) => {
  return (
    <button
      onClick={onClick}
      type={type}
      className={twMerge(
        "cursor-pointer disabled:cursor-default mx-auto xl:mr-0 w-full md:w-auto px-3 sm:px-7 py-3 md:py-3 uppercase font-semibold flex items-center justify-center text-sm md:text-md rounded-2xl  min-w-[10rem]",
        variant === "primary" &&
          "text-white bg-indigo-600 hover:bg-indigo-700 hover:enabled:bg-indigo-600 disabled:bg-indigo-400 disabled:cursor-not-allowed",
        variant === "secondary" &&
          "text-indigo-700 bg-indigo-100 border border-indigo-300 hover:bg-indigo-200 disabled:bg-indigo-100 disabled:cursor-not-allowed dark:text-indigo-50 dark:bg-indigo-900 dark:border-indigo-700 dark:hover:bg-indigo-800 dark:disabled:bg-indigo-900",
        variant === "accent" &&
          "text-white bg-astrorei-500 hover:bg-astrorei-600  disabled:bg-astrorei-300",
        className,
      )}
      disabled={disabled}
    >
      {loading ? <span className="animate-pulse">{loadingText}</span> : text}
    </button>
  );
};

export default FormButton;
